var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4171 9.67962L12.0755 10.0193C12.0755 10.0193 11.2636 10.8266 9.04734 8.62293C6.83109 6.41926 7.64303 5.61193 7.64303 5.61193L7.85814 5.39804C8.38805 4.87113 8.43801 4.02518 7.97568 3.40761L7.02994 2.14431C6.45771 1.37994 5.35197 1.27896 4.69609 1.93112L3.51889 3.10164C3.19367 3.42501 2.97574 3.84419 3.00217 4.3092C3.06978 5.49886 3.60804 8.05849 6.61152 11.0449C9.79661 14.2119 12.7851 14.3378 14.0072 14.2239C14.3938 14.1878 14.7299 13.9909 15.0008 13.7216L16.0663 12.6622C16.7854 11.9471 16.5827 10.7212 15.6625 10.221L14.2296 9.44206C13.6254 9.11362 12.8893 9.2101 12.4171 9.67962Z",
    fill: "#303030",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.66f6cb57123b2b6504b91cdea00b292c.svg";
export { ForwardRef as ReactComponent };